export const BROWN = '#AC7D59';
export const LIGHT_BROWN = '#d49e7a';
export const RED = 'red';

export const DARK_SIDE = '#444951';
export const MAIN_ORANGE_COLOR = '#E9822C';
